import { Navigate, Outlet  } from 'react-router-dom';

const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
  
    try {
      // Decode the JWT token to check its expiration
      const payload = JSON.parse(atob(token.split('.')[1])); // Decoding the JWT payload
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      return payload.exp > currentTime; // Check if token is expired
    } catch (error) {
      console.error("Error decoding token:", error);
      return false;
    }
  };
  

const ProtectedRoute = ({ children }) => {
  const isAuth = isAuthenticated();

  if (!isAuth) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;;
};

export default ProtectedRoute;
